export default {"src":"/_next/static/media/card-check.17a6b4a3.svg","height":24,"width":24};